import * as React from 'react';
import { Icon } from '../Icon/Icon';

export interface IVmsMenuProps {
    vms: Vms[];
    currentvmsId: string;
    currentRegion: string;
    allVmsPageUrl: string;
    favoriteVmsPageUrl: string;
}

export class Vms {
    public vmsPageId: string;
    public name: string;
    public url: string;
    public id: number;
    public vmsCssClass: string;
    public renderLinks: boolean;
    public noMessageRowVisible: boolean;
    public isCurrent: boolean;
    public isFavorite: boolean;
    public messageSignSource: string;
    public roadSignText: string;
    public textRow1: string;
    public textRow2: string;
    public textRow3: string;
    public connectedNoMessageRowVisible: boolean;
    public connectedRoadSignText: string;
    public connectedMessageSignSource: string;
    public messageSignVisible: boolean;
    public connectedTextRow1: string;
    public connectedTextRow2: string;
    public connectedTextRow3: string;
    public publicName: string;
}

class MenuItem {
    public icon: string;
    public name: string;
    public url?: string;

    constructor(icon: string, name: string, url?: string) {
        this.icon = icon;
        this.name = name;
        this.url = url;
    }
}

interface IVmsMenuState {
    items: MenuItem[];
    mobileopen?: boolean;
}

export class VmsMenu extends React.Component<IVmsMenuProps, IVmsMenuState> {
    constructor(props: IVmsMenuProps) {
        super(props);

        const items: MenuItem[] = [
            new MenuItem('icon-traffic-info-sign', 'Alla skyltar', this.props.allVmsPageUrl),
            new MenuItem('icon-star', 'Mina skyltar', this.props.favoriteVmsPageUrl),
        ];

        this.state = { items };
    }

    public render(): JSX.Element {
        const classFilter = this.state.mobileopen ? 'collapse d-md-block show' : 'd-md-block collapse';
        const mobileButtonText = this.state.mobileopen ? 'Dölj skyltval' : 'Visa skyltval';
        const mobileButtonClass = this.state.mobileopen ? 'btn btn-dark btn-filter d-md-none' : 'btn btn-dark btn-filter d-md-none show-arrow-down';

        return (
            <div>
                <button
                    type="button"
                    className={mobileButtonClass}
                    aria-expanded="false"
                    aria-controls="choices"
                    onClick={this.togglemobileMenu.bind(this)}
                >
                    {mobileButtonText}
                </button>
                <div id="choices" className={classFilter}>
                    <nav className="side-navigation">
                        <ul className="side-navigation__list">
                            {this.state.items.map((item, index) => (
                                <li key={index} className="side-navigation__item">
                                    <a className="side-navigation__link" href={item.url}>
                                        <div className="d-flex align-items-center camera-page__groupitem">
                                            <Icon symbol={item.icon} className="side-navigation__item-icon" />
                                            <span className="camera-page__itemName">{item.name}</span>
                                        </div>
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </nav>
                </div>
            </div>
        );
    }

    private togglemobileMenu() {
        this.setState({ mobileopen: !this.state.mobileopen });
    }
}
